<template>
  <div class="supplementary">
    <h3 class="title">Summary Events</h3>

    <sui-tab :menu="{ tabular: false, attached: true }" class="event-tabs">
      <sui-tab-pane title="Principal Components">
        <sui-dropdown
          class="event-dropdown"
          fluid
          :options="parseOptions(events.components)"
          search
          selection
          text="Select Event"
          v-model="currentComponent"
        />
        <img :src="imgUrl(currentComponent)" alt="event-summary" width="100%" />
      </sui-tab-pane>

      <sui-tab-pane title="Genetic Lesions">
        <sui-dropdown
          class="event-dropdown"
          fluid
          :options="parseOptions(events.genes)"
          search
          selection
          text="Select Event"
          v-model="currentGene"
        />
        <img :src="imgUrl(currentGene)" alt="event-summary" width="100%" />
      </sui-tab-pane>

      <sui-tab-pane title="Cytogenetic Events">
        <sui-dropdown
          class="event-dropdown"
          fluid
          :options="parseOptions(events.cytogenetics)"
          search
          selection
          text="Select Event"
          v-model="currentCytogenetic"
        />
        <img
          :src="imgUrl(currentCytogenetic)"
          alt="event-summary"
          width="100%"
        />
      </sui-tab-pane>
    </sui-tab>
  </div>
</template>

<script>
import events from "@/utils/events";

export default {
  name: "EventSummaries",
  data() {
    return {
      events,
      currentComponent: events.components[0],
      currentGene: events.genes[0],
      currentCytogenetic: events.cytogenetics[0]
    };
  },
  methods: {
    imgUrl(eventName) {
      return `${this.$config.staticUrl}/event_summary/${encodeURIComponent(
        eventName
      )}_overall_summary.png`;
    },
    parseOptions(options) {
      return options.map(i => {
        const text = i
          .replace(/t\(.*_.*\)/g, x => x.replace("_", ";"))
          .replace(/_/g, " ");
        return { key: i, value: i, text };
      });
    }
  }
};
</script>

<style lang="scss">
.supplementary {
  h3.title {
    color: #00113d;
    text-align: center;
  }

  .event-dropdown {
    padding-left: 16px;
    padding-right: 16px;
    font-family: DM Sans;

    input {
      border: 1px solid #dfe3ee;
      border-radius: 2px;
      color: #00113d;
      &:not(.search) {
        height: 50px;
      }
      &::placeholder {
        color: #c1c8d4;
        font-family: DM Sans;
      }
      &:focus {
        border-color: #2e68bd;
        border-radius: 2px;
      }
    }
  }
}
.event-tabs {
  .ui.menu.attached,
  .ui.tab {
    border: 1px solid #edeffa;
  }
  .ui.menu .item {
    color: #7d859b;
    background: #f6f9ff;
    height: 50px;
    &.active {
      color: #1e4781;
      background: white;
      font-weight: bold;
    }
    span {
      font-family: DM Sans;
      font-size: 14px;
    }
  }
}</style
>>
